import React from "react";

// utils
import { createEmergencyContactList } from "./CrewDetailEmergencyContacts.utils";

// queries
import { useQuery } from "@apollo/client";
import { GET_CREW_MEMBER_BY_ID_WITH_EMERGENCY_CONTACTS } from "../../../../../graphql/crewMember/crewMember.queries";

// components
import Card from "../../../../../components/cards/Card/Card.component";
import CardListItem from "../../../../../components/cards/CardListItem/CardListItem.component";

// icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressBook } from "@fortawesome/free-solid-svg-icons";

export default function CrewDetailEmergencyContacts({ id }) {
  let list = [];

  const { loading, error, data } = useQuery(
    GET_CREW_MEMBER_BY_ID_WITH_EMERGENCY_CONTACTS,
    {
      variables: { id },
    }
  );

  if (data && data.crewMember) {
    list = createEmergencyContactList(data.crewMember.emergencyContacts);
  }

  return (
    <Card
      header={{
        icon: (
          <FontAwesomeIcon icon={faAddressBook} size="2x" color="#707070" />
        ),
        title: "Emergency Contacts",
      }}
    >
      {list.map((contact, index) => {
        return (
          <React.Fragment key={index}>
            <CardListItem title={contact.name} subtitle={contact.phone} />
          </React.Fragment>
        );
      })}
    </Card>
  );
}
